const getOrigin = () => window.location.origin;

export const safeAuthReturnPath = (value, origin = getOrigin()) => {
  if (typeof value !== 'string' || !value || /[\\\u0000-\u001f\u007f]/.test(value) || value.startsWith('//')) return null;
  try {
    const url = new URL(value, origin);
    if (url.origin !== origin) return null;
    if (value.startsWith('/')) return value;
    if (/^https?:\/\//.test(value)) return url.pathname + url.search + url.hash;
  } catch (_) {}
  return null;
};

export const readAuthReturnPath = () => {
  try { return safeAuthReturnPath(sessionStorage.getItem('auth-redirect-next')); } catch (_) { return null; }
};

export const rememberAuthReturnPath = (path) => {
  const safePath = safeAuthReturnPath(path);
  if (safePath) {
    try { sessionStorage.setItem('auth-redirect-next', safePath); } catch (_) {}
  }
};

// Clerk preserves redirect_url across verification, but does not preserve next.
export const preserveAuthReturnQuery = (to, currentLocation) => {
  const origin = getOrigin();
  let destination;
  try { destination = new URL(to, origin); } catch (_) { return to; }
  if (destination.origin !== origin || !/^\/sign(?:in|up)(?:\/|$)/.test(destination.pathname)) return to;
  const isCurrentAuthPage = /^\/sign(?:in|up)(?:\/|$)/.test(currentLocation.pathname);
  const currentParams = new URLSearchParams(isCurrentAuthPage ? currentLocation.search : '');
  const next = safeAuthReturnPath(destination.searchParams.get('next'))
    || safeAuthReturnPath(currentParams.get('next'))
    || readAuthReturnPath()
    || safeAuthReturnPath(destination.searchParams.get('redirect_url'))
    || safeAuthReturnPath(currentParams.get('redirect_url'));
  if (!next) return to;
  destination.searchParams.set('next', next);
  destination.searchParams.set('redirect_url', next);
  ['source', 'gate_reason'].forEach((key) => {
    if (!destination.searchParams.has(key) && currentParams.has(key)) {
      destination.searchParams.set(key, currentParams.get(key));
    }
  });
  rememberAuthReturnPath(next);
  return destination.pathname + destination.search + destination.hash;
};
